import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { Layout } from '@.layout';
import { Tab, Tabs } from '@.partials';
import { LinkHelper, Tools } from '@.services';
import { Button } from '@.ui';
import { ProductsTable } from '@/Components/Pages/Data/Products';
import { isAllowArchiveBrand, isAllowRestoreBrand } from '@/entities/Brand';
import { PermissionProps } from '@/Types';

import { useBrandDetailPage } from '../lib/useBrandDetailPage';

export const BrandDetailPage: FC<PermissionProps> = (props) => {
    const { id } = useParams();

    const brandDetailPageControl = useBrandDetailPage(id);

    return (
        <Layout
            name="data"
            breadcrumbs={[
                { name: 'Brands', link: LinkHelper.dataBrands },
                { name: brandDetailPageControl.brandName, current: true },
            ]}
        >
            {brandDetailPageControl.modals}

            {brandDetailPageControl.brand && (
                <>
                    <h1>
                        {brandDetailPageControl.brandName}
                        <div>
                            <Button
                                color="transparent"
                                text={'Restore'}
                                onClick={() => brandDetailPageControl.restoreBrand.handleRestore(brandDetailPageControl.brand?.id)}
                                disabled={!isAllowRestoreBrand(brandDetailPageControl.brand) || !props.permissions?.delete}
                            />
                            <Button
                                color="transparent"
                                text={'Archive'}
                                onClick={() => brandDetailPageControl.archiveBrand.handleArchive(brandDetailPageControl.brand?.id)}
                                disabled={!isAllowArchiveBrand(brandDetailPageControl.brand) || !props.permissions?.update}
                            />
                            <Button
                                color="transparent"
                                text={'Delete'}
                                onClick={() => {
                                    if (brandDetailPageControl.brand?.id) {
                                        brandDetailPageControl.deleteBrand.deleteBrand(brandDetailPageControl.brand.id);
                                    }
                                }}
                                disabled={!props.permissions?.delete}
                            />
                            <Button
                                color="brown"
                                text="Edit"
                                onClick={brandDetailPageControl.toEdit}
                                disabled={!!brandDetailPageControl.brand.deleted_at || !props.permissions?.update}
                            />
                        </div>
                    </h1>
                    <Tabs>
                        <Tab name="General" path="general">
                            <div className="entity-page">
                                <div className="entity-page__container">
                                    <div>
                                        <div className="entity-page__item">
                                            <div className="bold">Name</div>
                                            <div>{brandDetailPageControl.brandName}</div>
                                        </div>
                                        <div className="entity-page__item">
                                            <div className="bold">Adding date</div>
                                            <div>{Tools.date.autoFormat(brandDetailPageControl.brand?.created_at * 1000)}</div>
                                        </div>
                                        <div className="entity-page__item">
                                            <div className="bold">Number of sales</div>
                                            <div>{brandDetailPageControl.brand?.sales_count}</div>
                                        </div>
                                    </div>
                                    <img src={brandDetailPageControl.brand?.image?.url} alt={brandDetailPageControl.brand?.image?.name} />
                                </div>
                                <div className="entity-page__item">
                                    <div className="bold">Whiffs</div>
                                    <div>{brandDetailPageControl.brand?.whiffs_count}</div>
                                </div>
                            </div>
                        </Tab>
                        <Tab name="Products" path="products">
                            <ProductsTable
                                filters={['ProductTypes', 'Ages', 'Sexes', 'Strengths', 'Occasions', 'Ingredients', 'IsArchived']}
                                brand_id={brandDetailPageControl.brand?.id}
                                hideActions={true}
                            />
                        </Tab>
                    </Tabs>
                </>
            )}
        </Layout>
    );
};
